var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('keep-alive',[(_vm.inHomeView)?_c(_setup.SmartLayoutC,{key:"home_nav",attrs:{"compId":"home_nav","mode":"basic","menus":_vm.filterMenus}}):_c(_setup.SmartLayoutC,{key:"history_nav",attrs:{"compId":"history_nav","mode":"basic","list":_vm.getNavigationList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }